import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import Form from "./Form"
import { AdminFormDialog } from "components/partials"
import {
    toRow,
    toTableData,
    getFormTitle
} from "common/helpers/admin-page-func.helper"
import { useAdminState, useAdminDispatch, ActionCreators } from "../Context"
import { CatalogsApi } from "../api"
import { useIsInputWritable } from "common/hooks"
import { Role } from "common/types"

const Dialog = () => {
    const { t } = useTranslation()
    const dispatch = useAdminDispatch()
    const { rowToEdit, params } = useAdminState()
    const { filter, pagination } = params
    const isWritable = useIsInputWritable()

    const [isDialogOpen, setIsDialogOpen] = useState(false)

    useEffect(() => {
        const hasFormData = Boolean(rowToEdit && Object.entries(rowToEdit).length)
        setIsDialogOpen(hasFormData)
    }, [rowToEdit])

    const formData = Boolean(rowToEdit) ? { ...rowToEdit } : {}

    const isEditMode = Boolean(formData.id)

    function onExited() {
        dispatch(ActionCreators.setToEdit(null))
    }

    function onClose() {
        setIsDialogOpen(false)
    }

    async function submitCallback(formData) {
        const requestFunc = isEditMode ? CatalogsApi.update : CatalogsApi.create
        let payload = formData

        const response = await requestFunc(payload)

        if (filter && pagination) {
            onClose()
            CatalogsApi.get({ filter, pagination, refetch: true }).then(response => {
                dispatch(ActionCreators.loaded(toTableData(response)))
            })
            return
        }

        if (isEditMode) {
            dispatch(ActionCreators.updateRow(toRow(response.data)))
        } else {
            dispatch(ActionCreators.addRow(toRow(response.data)))
        }
    }

    function onClickDelete() {
        dispatch(ActionCreators.setToDelete([rowToEdit]))
    }

    return (
        <AdminFormDialog
            shouldPromptOnCancel
            formData={formData}
            submitCallback={submitCallback}
            FormComponent={Form}
            DialogProps={{
                open: isDialogOpen,
                onClose,
                PaperProps: {
                    style: {
                        maxWidth: "max-content"
                    }
                },
                TransitionProps: {
                    onExited
                }
            }}
            DialogTitleProps={{
                children: getFormTitle(
                    t("view.admin.catalog"),
                    isEditMode ? "edit" : "create"
                )
            }}
            {...(isEditMode && {
                onClickDelete,

                SubmitButtonProps: {
                    getPropsFromFormData: formData => ({
                        ...(!isWritable(Role.Admin) && {
                            disabled: formData.setting?.version !== "Draft"
                        })
                    })
                }
            })}
        />
    )
}

export default Dialog
